(function () {
  const ROOT_SELECTOR = '[data-support-request]';

  const TOPICS = [
    {
      id: 'order',
      label: 'Sipariş ve Teslimat',
      subtitle: 'Sipariş durumu ve teslimat talebiniz için önce alışveriş yaptığınız yeri seçin; forma göre alanlar açılacaktır.',
      info: 'Siparişim nerede? taleplerinde sipariş numaranızı ve ürün bilgisini eksiksiz girmeniz süreci hızlandırır.',
      formHint: 'Sipariş durumu ve teslimat talebiniz için formu doldurun.',
      mainTopic: 'INFORMATION',
      subTopic: 'ORDER_AND_SHIPPING',
      showOrderFields: true,
      showFile: false,
      showOrders: true,
      iconSvg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 7h11v10H3z"/><path d="M14 10h4l3 3v4h-7"/><circle cx="7" cy="18" r="1.5"/><circle cx="17" cy="18" r="1.5"/></svg>',
    },
    {
      id: 'technical',
      label: 'Teknik Servis / Arıza',
      subtitle: 'Arıza kaydı oluşturmak için önce alışveriş yaptığınız yeri seçin.',
      info: 'Arıza kaydı için mümkünse fotoğraf veya video ekleyin; talebinizin daha hızlı sonuçlanmasını sağlar.',
      formHint: 'Teknik servis / arıza talebiniz için formu doldurun.',
      mainTopic: 'REQUEST',
      subTopic: 'FAULT_REPAIR_SERVICE',
      showOrderFields: true,
      showFile: true,
      showOrders: true,
      iconSvg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M14.7 6.3a4.5 4.5 0 0 0-6.1 6.1L3 18l3 3 5.6-5.6a4.5 4.5 0 0 0 6.1-6.1l-2.5 2.5-2.5-2.5z"/></svg>',
    },
    {
      id: 'payment',
      label: 'Ödeme / Fatura',
      subtitle: 'Fatura ve ödeme işlemleriniz için önce alışveriş yaptığınız yeri seçin.',
      info: 'Mağaza üzerinden geri ödeme taleplerinde slip / fiş ekran görüntüsü zorunludur.',
      formHint: 'Ödeme / fatura talebiniz için formu doldurun.',
      mainTopic: 'INFORMATION',
      subTopic: 'PAYMENT_AND_INVOICE',
      showOrderFields: true,
      showFile: false,
      showOrders: true,
      iconSvg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/><path d="M6 15h4"/></svg>',
    },
    {
      id: 'other',
      label: 'Geri Bildirim',
      subtitle: 'Geri bildirimleriniz için formu doldurun.',
      info: '',
      formHint: 'Geri bildirimleriniz için formu doldurun.',
      mainTopic: 'REQUEST',
      subTopic: 'CUSTOMER_SERVICE',
      showOrderFields: false,
      showFile: false,
      showOrders: false,
      iconSvg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M21 12a8 8 0 0 1-8 8H7l-4 3v-5.2A8 8 0 1 1 21 12z"/></svg>',
    },
  ];

  const TYPE_ALIASES = {
    'technical-service': { topicId: 'technical', subTopic: 'FAULT_REPAIR_SERVICE' },
    fault: { topicId: 'technical', subTopic: 'FAULT_REPAIR_SERVICE' },
    ticket: { topicId: 'other', subTopic: 'CUSTOMER_SERVICE' },
    order: { topicId: 'order', subTopic: 'ORDER_AND_SHIPPING' },
    shipping: { topicId: 'order', subTopic: 'ORDER_AND_SHIPPING' },
    payment: { topicId: 'payment', subTopic: 'PAYMENT_AND_INVOICE' },
    invoice: { topicId: 'payment', subTopic: 'PAYMENT_AND_INVOICE' },
    refund: { topicId: 'payment', subTopic: 'PAYMENT_AND_INVOICE' },
  };

  const SUBTOPIC_TO_TOPIC = {
    ORDER_AND_SHIPPING: 'order',
    FAULT_REPAIR_SERVICE: 'technical',
    PAYMENT_AND_INVOICE: 'payment',
    CUSTOMER_SERVICE: 'other',
    ORDER: 'order',
    SHIPPING: 'order',
    INVOICE: 'payment',
    PAYMENT: 'payment',
    GENERAL: 'other',
  };

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.from(root.querySelectorAll(selector));
  }

  function notify(root, message, type) {
    let wrap = document.querySelector('.support-request__toast-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'support-request__toast-wrap';
      document.body.appendChild(wrap);
    }

    const toast = document.createElement('div');
    toast.className = 'support-request__toast support-request__toast--' + (type || 'success');
    toast.textContent = message;
    wrap.appendChild(toast);

    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.3s ease';
      setTimeout(function () {
        toast.remove();
      }, 300);
    }, 4000);
  }

  function showSuccessScreen(root) {
    const view = qs(root, '[data-support-view]');
    const screen = qs(root, '[data-success-screen]');
    if (!screen) {
      notify(root, 'Talebiniz başarıyla oluşturuldu.', 'success');
      return;
    }
    if (view) view.hidden = true;
    screen.hidden = false;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function showFormView(root) {
    const view = qs(root, '[data-support-view]');
    const screen = qs(root, '[data-success-screen]');
    if (screen) screen.hidden = true;
    if (view) view.hidden = false;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).toLowerCase());
  }

  function normalizePhone(phone) {
    return String(phone || '').replace(/[^\d+\-\s()]/g, '').trim();
  }

  function digitCount(phone) {
    return String(phone || '').replace(/\D/g, '').length;
  }

  function getQueryParams() {
    return new URLSearchParams(window.location.search);
  }

  function setUrlSubTopic(subTopicValue) {
    const url = new URL(window.location.href);
    const next = new URLSearchParams();

    url.searchParams.forEach(function (value, key) {
      if (
        key === 'sub_topic' ||
        key === 'subTopic' ||
        key === 'mainTopic' ||
        key === 'main_topic' ||
        key === 'type'
      ) {
        return;
      }
      next.append(key, value);
    });

    next.set('sub_topic', subTopicValue || 'ORDER_AND_SHIPPING');
    url.search = next.toString();
    window.history.replaceState({}, '', url.toString());
  }

  function resolveInitialState(config) {
    const params = getQueryParams();
    const type = (params.get('type') || '').toLowerCase();
    const subTopic = (
      params.get('sub_topic') ||
      params.get('subTopic') ||
      ''
    ).toUpperCase();
    const creationType = (params.get('creationType') || '').toUpperCase();

    let topicId = 'order'; // Varsayılan: Sipariş ve Teslimat
    let resolvedCreation = creationType || config.defaultCreationType || 'SHOPIFY_CHAT_BOT';

    if (type && TYPE_ALIASES[type]) {
      topicId = TYPE_ALIASES[type].topicId;
    } else if (subTopic && SUBTOPIC_TO_TOPIC[subTopic]) {
      topicId = SUBTOPIC_TO_TOPIC[subTopic];
    }

    const topic = TOPICS.find(function (item) {
      return item.id === topicId;
    }) || TOPICS[0];

    return {
      topicId: topic.id,
      mainTopic: topic.mainTopic,
      subTopic: topic.subTopic,
      creationType: resolvedCreation,
      operationStatus: params.get('operationStatus') || config.defaultOperationStatus || 'INFO_PROVIDED',
    };
  }

  function setFieldVisibility(root, topic) {
    qsa(root, '[data-field-group]').forEach(function (el) {
      const group = el.getAttribute('data-field-group');
      let visible = true;

      if (group === 'order-no' || group === 'sku') {
        visible = Boolean(topic.showOrderFields);
      }
      if (group === 'file') {
        visible = Boolean(topic.showFile);
      }

      el.hidden = !visible;

      qsa(el, 'input, select, textarea').forEach(function (field) {
        if (visible) {
          field.removeAttribute('disabled');
        } else {
          field.setAttribute('disabled', 'disabled');
        }
      });
    });
  }

  function updateTopicUI(root, config, state) {
    const topic = TOPICS.find(function (item) {
      return item.id === state.topicId;
    });
    if (!topic) return;

    qsa(root, '[data-topic-btn]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-topic-btn') === topic.id);
    });

    const title = qs(root, '[data-topic-title]');
    const subtitle = qs(root, '[data-topic-subtitle]');

    if (title) title.textContent = topic.label;
    if (subtitle) subtitle.textContent = topic.subtitle || '';

    const ordersBlock = qs(root, '[data-orders-block]');
    const manualTitle = qs(root, '[data-manual-title]');
    const manualText = qs(root, '[data-manual-text]');

    if (ordersBlock) {
      ordersBlock.hidden = !(config.isLoggedIn && config.orders && config.orders.length && topic.showOrders);
    }

    if (manualTitle) {
      manualTitle.textContent = topic.showOrders && config.isLoggedIn
        ? 'Siparişiniz listede yok mu? Yeni talep oluşturun'
        : 'Geri Bildirim Formu';
    }

    if (manualText) {
      manualText.textContent = topic.showOrders && config.isLoggedIn
        ? 'Pazaryeri / mağaza alışverişi veya listede görünmeyen siparişler için formu doldurun.'
        : (topic.formHint || '');
    }

    setFieldVisibility(root, topic);

    const mainInput = qs(root, '[name="mainTopic"]');
    const subInput = qs(root, '[name="subTopic"]');
    if (mainInput) mainInput.value = topic.mainTopic;
    if (subInput) subInput.value = topic.subTopic;
  }

  function fillOrder(root, order, selectedSku, selectedTitle) {
    const orderNo = qs(root, '[name="orderNo"]');
    const sku = qs(root, '[name="sku"]');
    const description = qs(root, '[name="description"]');
    const skuValue = selectedSku != null
      ? selectedSku
      : (order.skus && order.skus.length ? order.skus[0] : '');

    if (orderNo) orderNo.value = order.name || '';
    if (sku) sku.value = skuValue || '';

    if (description) {
      const label = selectedTitle || order.title || '';
      if (label && skuValue) {
        description.value = order.name + ' / ' + label + ' (SKU: ' + skuValue + ') hakkında talep';
      } else if (label) {
        description.value = order.name + ' / ' + label + ' hakkında talep';
      } else {
        description.value = order.name + ' siparişi hakkında talep';
      }
    }

    qsa(root, '[data-order-id].support-request__order').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.getAttribute('data-order-id') === String(order.id));
    });

    qsa(root, '[data-bundle-item]').forEach(function (btn) {
      const sameOrder = btn.getAttribute('data-order-id') === String(order.id);
      const sameSku = (btn.getAttribute('data-sku') || '') === (skuValue || '');
      btn.classList.toggle('is-selected', sameOrder && sameSku);
    });

    qsa(root, '[data-order-product]').forEach(function (btn) {
      const sameOrder = btn.getAttribute('data-order-id') === String(order.id);
      const sameSku = (btn.getAttribute('data-sku') || '') === (skuValue || '');
      const isBundleParent = btn.getAttribute('data-is-bundle') === 'true';
      const wrap = btn.closest('[data-order-product-wrap]');
      const hasSelectedChild = !!(wrap && qs(wrap, '[data-bundle-item].is-selected'));
      btn.classList.toggle('is-selected', sameOrder && (sameSku || (isBundleParent && hasSelectedChild)));
    });
  }

  function isBundleSku(sku) {
    return !!(sku && /^B/i.test(String(sku).trim()));
  }

  function getBundleApiUrl(config, productCode) {
    var base = 'https://api.portal.dumanarge.com';
    return base + '/api/v1/customer-service-tickets/bundles/' + encodeURIComponent(productCode);
  }

  var bundleCache = {};

  function fetchBundleItems(config, productCode) {
    var code = String(productCode || '').trim();
    if (!code) return Promise.reject(new Error('SKU yok'));
    if (bundleCache[code]) return Promise.resolve(bundleCache[code]);

    var headers = { Accept: 'application/json' };

    return fetch(getBundleApiUrl(config, code), {
      method: 'GET',
      headers: headers,
    }).then(function (response) {
      if (!response.ok) throw new Error('Bundle isteği başarısız');
      return response.json();
    }).then(function (payload) {
      var items = (payload && payload.data && payload.data.linkedStockCards) || [];
      bundleCache[code] = items;
      return items;
    });
  }

  function closeOtherBundles(root, keepWrap) {
    qsa(root, '[data-order-product-wrap].is-bundle-open').forEach(function (wrap) {
      if (wrap === keepWrap) return;
      wrap.classList.remove('is-bundle-open');
      var btn = qs(wrap, '[data-order-product]');
      var panel = qs(wrap, '[data-bundle-items]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  function renderBundleItems(panel, items, order) {
    panel.innerHTML = '';
    if (!items.length) {
      var empty = document.createElement('p');
      empty.className = 'support-request__bundle-status';
      empty.textContent = 'Paket içinde ürün bulunamadı.';
      panel.appendChild(empty);
      return;
    }

    items.forEach(function (item) {
      var code = item.productCode || '';
      var name = item.nameTr || item.nameEn || code;
      var qty = item.quantity != null ? item.quantity : 1;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'support-request__bundle-item';
      btn.setAttribute('data-bundle-item', '');
      btn.setAttribute('data-order-id', String(order.id));
      btn.setAttribute('data-sku', code);
      btn.setAttribute('data-title', name);

      if (item.productImage) {
        var img = document.createElement('img');
        img.className = 'support-request__order-product-thumb';
        img.src = item.productImage;
        img.alt = '';
        img.width = 40;
        img.height = 40;
        img.loading = 'lazy';
        btn.appendChild(img);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'support-request__order-product-thumb';
        placeholder.setAttribute('aria-hidden', 'true');
        btn.appendChild(placeholder);
      }

      var meta = document.createElement('span');
      meta.className = 'support-request__order-product-meta';

      var titleEl = document.createElement('span');
      titleEl.className = 'support-request__order-product-title';
      titleEl.textContent = name;

      var skuEl = document.createElement('span');
      skuEl.className = 'support-request__order-product-sku';
      skuEl.textContent = 'SKU: ' + (code || '—') + ' · ' + qty + ' adet';

      meta.appendChild(titleEl);
      meta.appendChild(skuEl);
      btn.appendChild(meta);
      panel.appendChild(btn);
    });
  }

  function openBundlePanel(root, config, productBtn, order) {
    var wrap = productBtn.closest('[data-order-product-wrap]');
    var panel = wrap ? qs(wrap, '[data-bundle-items]') : null;
    var sku = productBtn.getAttribute('data-sku') || '';
    if (!wrap || !panel) return Promise.resolve();

    closeOtherBundles(root, wrap);
    wrap.classList.add('is-bundle-open');
    productBtn.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    panel.innerHTML = '<p class="support-request__bundle-status">Paket içeriği yükleniyor…</p>';

    return fetchBundleItems(config, sku)
      .then(function (items) {
        renderBundleItems(panel, items, order);
      })
      .catch(function () {
        panel.innerHTML = '<p class="support-request__bundle-status support-request__bundle-status--error">Paket içeriği alınamadı. Tekrar deneyin.</p>';
      });
  }

  function toggleOrderProducts(root, wrap, open) {
    if (!wrap) return;
    const shouldOpen = open == null ? !wrap.classList.contains('is-open') : open;
    qsa(root, '[data-order-wrap].is-open').forEach(function (el) {
      if (el !== wrap) {
        el.classList.remove('is-open');
        const btn = qs(el, '[data-order-id].support-request__order');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        closeOtherBundles(root, null);
      }
    });
    wrap.classList.toggle('is-open', shouldOpen);
    const orderBtn = qs(wrap, '[data-order-id].support-request__order');
    if (orderBtn) orderBtn.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    if (!shouldOpen) closeOtherBundles(root, null);
  }

  var MAX_FILES = 20;
  var MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024;

  function formatFileSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function syncFileInput(input, files) {
    var transfer = new DataTransfer();
    files.forEach(function (file) {
      transfer.items.add(file);
    });
    input.files = transfer.files;
  }

  function renderFileList(uploadRoot, files) {
    var list = qs(uploadRoot, '[data-file-list]');
    if (!list) return;

    qsa(list, '[data-preview-url]').forEach(function (el) {
      var url = el.getAttribute('data-preview-url');
      if (url) URL.revokeObjectURL(url);
    });

    list.innerHTML = '';
    if (!files.length) {
      list.hidden = true;
      return;
    }

    list.hidden = false;
    files.forEach(function (file, index) {
      var li = document.createElement('li');
      li.className = 'support-request__file-item';

      var isImage = (file.type && file.type.indexOf('image/') === 0) ||
        /\.(png|jpe?g|gif|webp|bmp|svg|ico)$/i.test(file.name);
      var isVideo = (file.type && file.type.indexOf('video/') === 0) ||
        /\.(mp4|webm|mov|m4v)$/i.test(file.name);

      var previewHtml = '';
      if (isImage) {
        var imageUrl = URL.createObjectURL(file);
        previewHtml =
          '<div class="support-request__file-item-preview">' +
            '<img src="' + imageUrl + '" alt="" data-preview-url="' + imageUrl + '" loading="lazy">' +
          '</div>';
      } else if (isVideo) {
        var videoUrl = URL.createObjectURL(file);
        previewHtml =
          '<div class="support-request__file-item-preview">' +
            '<video src="' + videoUrl + '" muted data-preview-url="' + videoUrl + '"></video>' +
          '</div>';
      } else {
        previewHtml =
          '<div class="support-request__file-item-preview">' +
            '<span class="support-request__file-item-fallback" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">' +
                '<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/>' +
                '<path d="M14 3v5h5"/>' +
              '</svg>' +
            '</span>' +
          '</div>';
      }

      li.innerHTML =
        previewHtml +
        '<span class="support-request__file-item-meta">' +
          '<span class="support-request__file-item-name"></span>' +
          '<span class="support-request__file-item-size"></span>' +
        '</span>' +
        '<button type="button" class="support-request__file-item-remove" data-remove-file="' + index + '" aria-label="Dosyayı kaldır">✕</button>';

      qs(li, '.support-request__file-item-name').textContent = file.name;
      qs(li, '.support-request__file-item-size').textContent = formatFileSize(file.size);
      list.appendChild(li);
    });
  }

  function initFileUpload(root) {
    var uploadRoot = qs(root, '[data-file-upload]');
    if (!uploadRoot) return;

    var input = qs(uploadRoot, '[name="files"]');
    var dropzone = qs(uploadRoot, '[data-dropzone]');
    if (!input || !dropzone) return;

    var selectedFiles = [];

    window.addEventListener('dragover', function (e) { e.preventDefault(); }, false);
    window.addEventListener('drop', function (e) { e.preventDefault(); }, false);

    function applyFiles(nextFiles, announceError) {
      var merged = [];
      var seen = {};
      var error = '';

      nextFiles.forEach(function (file) {
        var key = file.name + ':' + file.size + ':' + file.lastModified;
        if (seen[key]) return;
        seen[key] = true;

        if (file.size > MAX_FILE_SIZE_BYTES) {
          error = '"' + file.name + '" dosyası 20 MB sınırını aşıyor.';
          return;
        }
        merged.push(file);
      });

      if (merged.length > MAX_FILES) {
        error = 'En fazla ' + MAX_FILES + ' dosya yükleyebilirsiniz.';
        merged = merged.slice(0, MAX_FILES);
      }

      selectedFiles = merged;
      syncFileInput(input, selectedFiles);
      renderFileList(uploadRoot, selectedFiles);

      if (error && announceError) notify(root, error, 'error');
    }

    input.addEventListener('change', function () {
      var incoming = Array.from(input.files || []);
      applyFiles(selectedFiles.concat(incoming), true);
    });

    uploadRoot.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('[data-remove-file]');
      if (!removeBtn) return;
      event.preventDefault();
      var index = parseInt(removeBtn.getAttribute('data-remove-file'), 10);
      if (Number.isNaN(index)) return;
      selectedFiles = selectedFiles.filter(function (_file, i) {
        return i !== index;
      });
      syncFileInput(input, selectedFiles);
      renderFileList(uploadRoot, selectedFiles);
    });

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (eventName) {
      dropzone.addEventListener(eventName, function (event) {
        event.preventDefault();
        event.stopPropagation();
      }, false);
    });

    ['dragenter', 'dragover'].forEach(function (eventName) {
      dropzone.addEventListener(eventName, function () {
        dropzone.classList.add('is-dragover');
      }, false);
    });

    ['dragleave', 'drop'].forEach(function (eventName) {
      dropzone.addEventListener(eventName, function () {
        dropzone.classList.remove('is-dragover');
      }, false);
    });

    dropzone.addEventListener('drop', function (event) {
      var dt = event.dataTransfer;
      var incoming = Array.from((dt && dt.files) || []);
      if (!incoming.length) return;
      applyFiles(selectedFiles.concat(incoming), true);
    }, false);

    uploadRoot._clearFiles = function () {
      selectedFiles = [];
      syncFileInput(input, selectedFiles);
      renderFileList(uploadRoot, selectedFiles);
    };
  }

  function collectPayload(root, config, state) {
    const get = function (name) {
      const el = qs(root, '[name="' + name + '"]');
      return el && !el.disabled ? el.value.trim() : '';
    };

    const phone = normalizePhone(get('customerPhone'));
    const firstName = get('firstName');
    const lastName = get('lastName');
    const email = get('email');
    const description = get('description');
    const orderNo = get('orderNo');
    const sku = get('sku');
    const fileInput = qs(root, '[name="files"]');
    const files = fileInput && fileInput.files ? Array.from(fileInput.files) : [];

    const selected = TOPICS.find(function (item) {
      return item.id === state.topicId;
    });

    return {
      fields: {
        customerPhone: phone || '',
        firstName: firstName || '',
        lastName: lastName || '',
        email: email || '',
        description: description || '',
        orderNo: orderNo || '',
        sku: sku || '',
        mainTopic: (selected && selected.mainTopic) || get('mainTopic') || state.mainTopic || '',
        subTopic: (selected && selected.subTopic) || get('subTopic') || state.subTopic || '',
        operationStatus: get('operationStatus') || state.operationStatus || '',
        creationType: get('creationType') || state.creationType || config.defaultCreationType || 'SHOPIFY_CHAT_BOT',
      },
      files: files,
    };
  }

  function validate(root, payload, topic) {
    const fields = payload.fields || {};
    const requiredNames = ['firstName', 'lastName', 'customerPhone', 'email', 'description'];

    if (topic.showOrderFields) {
      requiredNames.push('orderNo', 'sku');
    }

    for (let i = 0; i < requiredNames.length; i += 1) {
      const name = requiredNames[i];
      const el = qs(root, '[name="' + name + '"]');
      if (!el || el.disabled) continue;
      if (!el.value.trim()) {
        return 'Lütfen zorunlu alanları doldurun.';
      }
    }

    if (fields.email && !isValidEmail(fields.email)) {
      return 'Geçerli bir e-posta adresi girin.';
    }

    if (fields.customerPhone && digitCount(fields.customerPhone) < 10) {
      return 'Telefon numarası en az 10 haneli olmalıdır.';
    }

    const files = payload.files || [];

    if (topic.showFile && !files.length) {
      return 'Arıza kaydı için fotoğraf veya video ekleyin.';
    }

    if (files.length > MAX_FILES) {
      return 'En fazla ' + MAX_FILES + ' dosya yükleyebilirsiniz.';
    }

    for (let i = 0; i < files.length; i += 1) {
      if (files[i].size > MAX_FILE_SIZE_BYTES) {
        return '"' + files[i].name + '" dosyası 20 MB sınırını aşıyor.';
      }
    }

    return '';
  }

  function buildFormData(payload) {
    const formData = new FormData();
    const fields = payload.fields || {};

    Object.keys(fields).forEach(function (key) {
      formData.append(key, fields[key] == null ? '' : String(fields[key]));
    });

    (payload.files || []).forEach(function (file) {
      formData.append('files', file);
    });

    return formData;
  }

  async function submitForm(root, config, state) {
    const topic = TOPICS.find(function (item) {
      return item.id === state.topicId;
    });
    const payload = collectPayload(root, config, state);
    const error = validate(root, payload, topic || {});
    if (error) {
      notify(root, error, 'error');
      return;
    }

    const submitBtn = qs(root, '[data-submit]');
    if (submitBtn && submitBtn.disabled) return;
    const fingerprint = JSON.stringify({ fields: payload.fields, files: (payload.files || []).map(file => [file.name, file.size, file.type, file.lastModified]) });
    if (!state.submission || state.submission.fingerprint !== fingerprint) {
      state.submission = { fingerprint, key: crypto.randomUUID() };
    }
    const originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Gönderiliyor...';
    }

    try {
      const headers = {
        Accept: 'application/json',
        'Idempotency-Key': state.submission.key,
      };

      const response = await fetch(config.apiUrl, {
        method: 'POST',
        headers: headers,
        body: buildFormData(payload),
      });

      if (!response.ok) {
        let message = 'Talebiniz gönderilemedi. Lütfen tekrar deneyin.';
        try {
          const data = await response.json();
          if (data && (data.message || data.error)) {
            message = data.message || data.error;
          }
        } catch (e) {
          // ignore
        }
        notify(root, message, 'error');
        return;
      }

      state.submission = null;
      showSuccessScreen(root);

      qsa(root, 'input:not([readonly]):not([type="hidden"]), textarea, select:not([disabled])').forEach(function (el) {
        if (el.name === 'customerPhone') return;
        if (el.type === 'file') {
          el.value = '';
        } else if (!el.readOnly) {
          el.value = el.tagName === 'SELECT' ? (el.options[0] && el.options[0].value) || '' : '';
        }
      });

      var uploadRoot = qs(root, '[data-file-upload]');
      if (uploadRoot && typeof uploadRoot._clearFiles === 'function') {
        uploadRoot._clearFiles();
      }

      qsa(root, '[data-order-id]').forEach(function (btn) {
        btn.classList.remove('is-selected');
      });
      qsa(root, '[data-order-wrap].is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
    } catch (err) {
      notify(root, 'Bağlantı hatası oluştu. Lütfen tekrar deneyin.', 'error');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText || 'Talebi Gönder';
      }
    }
  }

  function init(root) {
    let config = {};
    try {
      const configId = root.getAttribute('data-config-id');
      const configEl = configId ? document.getElementById(configId) : null;
      if (configEl) {
        config = JSON.parse(configEl.textContent || '{}');
      } else {
        config = JSON.parse(root.getAttribute('data-config') || '{}');
      }
    } catch (e) {
      config = {};
    }

    config.topics = TOPICS;

    const state = resolveInitialState(config);
    updateTopicUI(root, config, state);
    setUrlSubTopic(state.subTopic || 'ORDER_AND_SHIPPING');

    const creationTypeInput = qs(root, '[name="creationType"]');
    const operationStatusInput = qs(root, '[name="operationStatus"]');
    if (creationTypeInput) creationTypeInput.value = state.creationType;
    if (operationStatusInput) operationStatusInput.value = state.operationStatus;

    const ordersBlock = qs(root, '[data-orders-block]');
    const ordersToggle = qs(root, '[data-orders-toggle]');
    const hasOrders = !!(config.isLoggedIn && config.orders && config.orders.length);
    if (ordersBlock && ordersToggle) {
      if (hasOrders) {
        ordersBlock.classList.remove('is-collapsed');
        ordersToggle.setAttribute('aria-expanded', 'true');
      } else {
        ordersBlock.classList.add('is-collapsed');
        ordersToggle.setAttribute('aria-expanded', 'false');
      }
    }

    qsa(root, '[data-topic-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const topicId = btn.getAttribute('data-topic-btn');
        const topic = TOPICS.find(function (item) {
          return item.id === topicId;
        });
        if (!topic) return;

        state.topicId = topic.id;
        state.mainTopic = topic.mainTopic;
        state.subTopic = topic.subTopic;
        updateTopicUI(root, config, state);
        setUrlSubTopic(topic.subTopic);
      });
    });

    qsa(root, '[data-orders-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        const block = toggle.closest('[data-orders-block]');
        if (!block) return;
        const isCollapsed = block.classList.contains('is-collapsed');

        if (isCollapsed) {
          block.classList.remove('is-collapsed');
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          block.classList.add('is-collapsed');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });

    qsa(root, '[data-order-id].support-request__order').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const orderId = btn.getAttribute('data-order-id');
        const needsPick = btn.getAttribute('data-needs-pick') === 'true';
        const order = (config.orders || []).find(function (item) {
          return String(item.id) === String(orderId);
        });
        if (!order) return;

        const wrap = btn.closest('[data-order-wrap]');
        const singleSku = btn.getAttribute('data-sku') || (order.skus && order.skus[0]) || '';

        if (needsPick || isBundleSku(singleSku)) {
          toggleOrderProducts(root, wrap);
          const orderNo = qs(root, '[name="orderNo"]');
          if (orderNo) orderNo.value = order.name || '';
          qsa(root, '[data-order-id].support-request__order').forEach(function (el) {
            el.classList.toggle('is-selected', el.getAttribute('data-order-id') === String(order.id));
          });
          return;
        }

        qsa(root, '[data-order-wrap].is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
        closeOtherBundles(root, null);
        fillOrder(root, order, singleSku, order.title || '');
      });
    });

    qsa(root, '[data-order-product]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const orderId = btn.getAttribute('data-order-id');
        const order = (config.orders || []).find(function (item) {
          return String(item.id) === String(orderId);
        });
        if (!order) return;

        const sku = btn.getAttribute('data-sku') || '';
        const isBundle = btn.getAttribute('data-is-bundle') === 'true' || isBundleSku(sku);

        if (isBundle) {
          const wrap = btn.closest('[data-order-product-wrap]');
          const isOpen = wrap && wrap.classList.contains('is-bundle-open');
          const orderNo = qs(root, '[name="orderNo"]');
          if (orderNo) orderNo.value = order.name || '';
          qsa(root, '[data-order-id].support-request__order').forEach(function (el) {
            el.classList.toggle('is-selected', el.getAttribute('data-order-id') === String(order.id));
          });

          if (isOpen) {
            wrap.classList.remove('is-bundle-open');
            btn.setAttribute('aria-expanded', 'false');
            const panel = qs(wrap, '[data-bundle-items]');
            if (panel) panel.hidden = true;
            return;
          }

          openBundlePanel(root, config, btn, order);
          return;
        }

        closeOtherBundles(root, null);
        fillOrder(
          root,
          order,
          sku,
          btn.getAttribute('data-title') || ''
        );
      });
    });

    root.addEventListener('click', function (event) {
      const bundleBtn = event.target.closest('[data-bundle-item]');
      if (!bundleBtn || !root.contains(bundleBtn)) return;

      const orderId = bundleBtn.getAttribute('data-order-id');
      const order = (config.orders || []).find(function (item) {
        return String(item.id) === String(orderId);
      });
      if (!order) return;

      fillOrder(
        root,
        order,
        bundleBtn.getAttribute('data-sku') || '',
        bundleBtn.getAttribute('data-title') || ''
      );
    });

    initFileUpload(root);

    const form = qs(root, '[data-support-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitForm(root, config, state);
      });
    }

    const cancelBtn = qs(root, '[data-cancel]');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function () {
        if (window.history.length > 1) {
          window.history.back();
        } else {
          window.location.href = '/';
        }
      });
    }

    const newRequestBtn = qs(root, '[data-new-request]');
    if (newRequestBtn) {
      newRequestBtn.addEventListener('click', function () {
        showFormView(root);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    qsa(document, ROOT_SELECTOR).forEach(init);
  });
})();